var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackSideimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 104,
    viewBox: "0 0 106 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 19.7H82C82 19.7 66 20 66 36V52C66 52 66 68 82 68V84L98 68H130",
    stroke: "#AFE26C",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130 35.98H82",
    stroke: "#AFE26C",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114 52H82",
    stroke: "#AFE26C",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 -12H50C66.14 -12 66 4.54 66 4.54V18.92C66 18.92 66 35.46 50 35.46V52L34 35.46H2",
    stroke: "#AFE26C",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.02C20.2091 16.02 22 14.2292 22 12.02C22 9.81088 20.2091 8.02002 18 8.02002C15.7909 8.02002 14 9.81088 14 12.02C14 14.2292 15.7909 16.02 18 16.02Z",
    fill: "#AFE26C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16.02C36.2091 16.02 38 14.2292 38 12.02C38 9.81088 36.2091 8.02002 34 8.02002C31.7909 8.02002 30 9.81088 30 12.02C30 14.2292 31.7909 16.02 34 16.02Z",
    fill: "#AFE26C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50 16.02C52.2091 16.02 54 14.2292 54 12.02C54 9.81088 52.2091 8.02002 50 8.02002C47.7909 8.02002 46 9.81088 46 12.02C46 14.2292 47.7909 16.02 50 16.02Z",
    fill: "#AFE26C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2 116H49.43L58 92C58 92 58 76 42 76H26L34 60C34 60 34 52 26 52L2 84",
    stroke: "#AFE26C",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackSideimage);
export default __webpack_public_path__ + "static/media/feedback-sideimage.ac268817d834bb272a990024b9833d0e.svg";
export { ForwardRef as ReactComponent };